/*
  PLP category-pill slider progress bar.

  On mobile the sibling-category pills are one scrolling row (uk.diesel.com —
  see test/mobilePLP.jpg) with a red thumb on a grey track beneath. The thumb's
  width is the visible fraction of the row and it travels the leftover track
  width in step with scrollLeft, so it reads as a scrollbar rather than a
  progress meter that fills.

  Values go out as CSS variables, so the styling (colour, height, RTL flip)
  stays in the section's stylesheet.

  RTL: scrollLeft is negative-or-zero in RTL, so the fraction is computed from
  its absolute value and the CSS flips the translate direction.
*/
(function () {
  'use strict';

  if (window.__dieselPillSliderBound) return;
  window.__dieselPillSliderBound = true;

  function update(slider) {
    var track = slider.querySelector('[data-pill-track]');
    var thumb = slider.querySelector('[data-pill-thumb]');
    if (!track || !thumb) return;

    var visible = track.clientWidth;
    var total = track.scrollWidth;

    // Nothing to scroll: hide the bar rather than show a full-width thumb.
    if (total <= visible + 1) {
      slider.classList.add('is-static');
      thumb.style.setProperty('--pill-thumb-w', '100%');
      thumb.style.setProperty('--pill-thumb-x', '0px');
      return;
    }
    slider.classList.remove('is-static');

    var ratio = visible / total;
    var thumbW = Math.max(visible * ratio, 24); // floor so it stays grabbable
    var maxScroll = total - visible;
    var progress = Math.abs(track.scrollLeft) / maxScroll;
    if (progress > 1) progress = 1;

    thumb.style.setProperty('--pill-thumb-w', thumbW + 'px');
    thumb.style.setProperty('--pill-thumb-x', (progress * (visible - thumbW)) + 'px');
  }

  function updateAll() {
    document.querySelectorAll('[data-pill-slider]').forEach(update);
  }

  // Scroll events don't bubble, so listen in the capture phase — this also
  // survives the grid re-rendering under it.
  document.addEventListener(
    'scroll',
    function (e) {
      var track = e.target && e.target.closest && e.target.closest('[data-pill-track]');
      if (!track) return;
      var slider = track.closest('[data-pill-slider]');
      if (slider) update(slider);
    },
    { capture: true, passive: true }
  );

  window.addEventListener('resize', updateAll);

  /* Bring the active pill into view, so a deep category isn't hidden off-screen.

     Deliberately the MINIMUM scroll rather than centring it: centring left the
     row sitting mid-scroll on load, cut off at both edges with "View all" out of
     sight. Scrolling only when the pill is actually out of view means the common
     case — an active pill near the start — opens at the beginning of the row,
     which is how uk presents it. */
  function revealActive() {
    document.querySelectorAll('[data-pill-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-pill-track]');
      var active = track && track.querySelector('.diesel-cat-pill--active');
      if (!track || !active) return;
      if (track.scrollWidth <= track.clientWidth + 1) return;

      var pad = 24; // leave the pill clear of the row's inset edge
      var left = active.offsetLeft;
      var right = left + active.offsetWidth;
      var viewLeft = track.scrollLeft;
      var viewRight = viewLeft + track.clientWidth;

      if (left < viewLeft + pad) {
        track.scrollLeft = Math.max(0, left - pad);
      } else if (right > viewRight - pad) {
        track.scrollLeft = right - track.clientWidth + pad;
      }
    });
  }

  function init() {
    revealActive();
    updateAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Late webfont/image layout shifts change scrollWidth after first paint.
  window.addEventListener('load', updateAll);
})();
